const Round = (value) => {
    value = parseFloat(value);
    return Math.round(value * 100) / 100;
};

export default Round;
